module.exports = __webpack_public_path__ + "static/media/about_img_1.558a04e9.jpg";